// 转义特殊字符
export function replaceFun( data ){
  const replaceFun = (rs) =>{
    switch(rs) {
      case '&lt;':
        return '<';
      case '&gt;':
        return '>';
      case '&#39;':
        return '\'';
      case '&quot;':
        return '"';
      case '&amp;':
        return '&';
    }
  };
  if(data){
    data = data.replace(/(&lt;)|(&gt;)|(&#39;)|(&quot;)|(&amp;)/g,replaceFun);
  }
  return data;
}

// 上面的反过来
export function HTMLEncode(html){
  let div = document.createElement('div');
  if(!div.textContent){
    div.textContent = html;
  } else {
    div.innerText = html;
  }
  const output = div.innerHTML;
  div = null;
  return output;
}


// WEBPACK FOOTER //
// ./src/scripts/utils/processingTools.js